import { useMemo, useState } from "react";
import { createTeamDm } from "../../api/client";
import {
  openCockpitPathFromVideo,
  resolveOfficeLifePaths,
} from "./voOfficeLife";

export { openCockpitPathFromVideo };

export function useVoFloorOfficeLife({ enabled = false, returnPath = "" } = {}) {
  const paths = useMemo(() => resolveOfficeLifePaths(returnPath), [returnPath]);
  const [sayHiBusyId, setSayHiBusyId] = useState(0);

  const sayHiToUser = async (userId) => {
    const uid = Number(userId);
    if (!enabled || !uid || sayHiBusyId) return null;
    setSayHiBusyId(uid);
    try {
      const space = await createTeamDm({ userId: uid });
      const spaceId = Number(space?.id || space?.spaceId || space?.data?.id);
      openCockpitPathFromVideo(paths.chatSpace(spaceId));
      return spaceId;
    } finally {
      setSayHiBusyId(0);
    }
  };

  return {
    sayHiToUser,
    sayHiBusyId,
  };
}
